import { render, staticRenderFns } from "./ResourceViewTimeline.vue?vue&type=template&id=aa5d4aca&scoped=true"
import script from "./ResourceViewTimeline.vue?vue&type=script&lang=js"
export * from "./ResourceViewTimeline.vue?vue&type=script&lang=js"
import style0 from "./ResourceViewTimeline.vue?vue&type=style&index=0&id=aa5d4aca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5d4aca",
  null
  
)

export default component.exports